import CLOSE_BUTTON from './svgs/close_button.svg';
import DISABLED_BUTTON from './svgs/disabled_button.svg';
import DISABLED_BUTTON_REVERSE from './svgs/disabled_button_reverse.svg';
import PAUSE_BUTTON from './svgs/pause_button.svg';
import PAUSE_BUTTON_HOVER from './svgs/pause_button_hover.svg';
import PLAY_BUTTON from './svgs/play_button.svg';
import PLAY_BUTTON_HOVER from './svgs/play_button_hover.svg';
import RESET_BUTTON from './svgs/reset_button.svg';
import RESET_BUTTON_HOVER from './svgs/reset_button_hover.svg';
import RESTORE_BUTTON from './svgs/restore_button.svg';
import RESTORE_BUTTON_HOVER from './svgs/restore_button_hover.svg';

export default {
  CLOSE_BUTTON,
  DISABLED_BUTTON,
  DISABLED_BUTTON_REVERSE,
  PAUSE_BUTTON,
  PAUSE_BUTTON_HOVER,
  PLAY_BUTTON,
  PLAY_BUTTON_HOVER,
  RESET_BUTTON,
  RESET_BUTTON_HOVER,
  RESTORE_BUTTON,
  RESTORE_BUTTON_HOVER,
};
